export const ACTIONS = {
  SET_TRANSFORMATION_VALUE: "SET_TRANSFORMATION_VALUE",
};

export const setTransformationValue = (data) => {
  return { type: ACTIONS.SET_TRANSFORMATION_VALUE, payload: data };
};
